import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BeneficiaryComplement } from '../../beneficiaries/beneficiary-details/complement/beneficiaryComplement';
import { Complement } from '../../beneficiaries/beneficiary-details/complement/complement';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryComplementsService {
  public complementUpdate: Subject<BeneficiaryComplement> = new Subject<BeneficiaryComplement>();
  public complementUpdated$: Observable<BeneficiaryComplement> = this.complementUpdate.asObservable();
  constructor(private readonly api: ApiService) {}

  public async findById(idComplement: number): Promise<BeneficiaryComplement> {
    const uri: string = environment.api.complements + '/' + idComplement + '/details';
    const result: BeneficiaryComplement = await this.api.get<BeneficiaryComplement>(uri);
    return BeneficiaryComplement.fromJson(result);
  }

  public async updateComplementBeneficiary(idBeneficiary: number, complement: Complement): Promise<number> {
    const id: number = await this.api.put(environment.api.complements + '/' + idBeneficiary, complement);
    this.complementUpdate.next(undefined);
    return id;
  }
}
